<template>
  <v-app class="emp-layout">
    <div class="emp-content-wrapper">
      <slot></slot>
    </div>
    
    <!-- 하단 네비게이션 바 -->
    <div class="emp-bottom-nav">
      <router-link
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        class="nav-item"
        :class="{ active: isActiveRoute(item.path) }"
      >
        <div class="nav-icon-wrapper">
          <v-icon :size="24" :color="isActiveRoute(item.path) ? item.activeColor : '#9ca3af'">
            {{ item.icon }}
          </v-icon>
        </div>
        <span class="nav-label">{{ item.label }}</span>
      </router-link>
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

const route = useRoute();

// 사원 전용 메뉴 (센터장/관리자용보다 제한적)
const navItems = [
  {
    path: '/emp/schedule',
    label: '일정',
    icon: 'mdi-calendar',
    activeColor: '#059669'
  },
  {
    path: '/emp/payslip',
    label: '급여',
    icon: 'mdi-currency-krw',
    activeColor: '#059669'
  },
  {
    path: '/emp/home',
    label: '홈',
    icon: 'mdi-home',
    activeColor: '#059669'
  },
  {
    path: '/emp/documents',
    label: '문서함',
    icon: 'mdi-folder-file',
    activeColor: '#059669'
  },
  {
    path: '/emp/more',
    label: '더보기',
    icon: 'mdi-dots-horizontal',
    activeColor: '#059669'
  }
];

const isActiveRoute = (path: string): boolean => {
  // 더보기 탭은 관련 하위 페이지들도 활성화
  if (path === '/emp/more') {
    return route.path === '/emp/more' || 
           route.path === '/emp/myinfo' || 
           route.path === '/emp/settings' ||
           route.path.startsWith('/emp/notice');
  }
  return route.path === path || route.path.startsWith(path + '/');
};
</script>

<style scoped lang="scss">
.emp-layout {
  width: 100%;
  min-height: 100vh;
  background-color: #f0fdf4;
  font-family: 'Noto Sans KR', sans-serif;
}

.emp-content-wrapper {
  flex: 1;
  padding-bottom: 70px;
  min-height: calc(100vh - 70px);
  overflow-y: auto;
}

.emp-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 64px;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  text-decoration: none;
  transition: all 0.2s ease;
  border-radius: 12px;
  min-width: 60px;
  
  .nav-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    transition: all 0.2s ease;
  }
  
  .nav-label {
    font-size: 11px;
    font-weight: 500;
    color: #9ca3af;
    margin-top: 4px;
    transition: all 0.2s ease;
  }
  
  &.active {
    .nav-icon-wrapper {
      background: rgba(5, 150, 105, 0.1);
    }
    
    .nav-label {
      color: #059669;
      font-weight: 600;
    }
  }
  
  &:hover:not(.active) {
    .nav-label {
      color: #6b7280;
    }
  }
}

@media (max-width: 400px) {
  .nav-item {
    min-width: 50px;
    padding: 8px 8px;
    
    .nav-label {
      font-size: 10px;
    }
  }
}
</style>



